import { ButtonDefaultProps } from "./types";

const ButtonDefault = ({ css: cssProps, ...props }: ButtonDefaultProps) => {
    return (
        <button
            {...props}
            css={[
                {
                    padding: "0",
                    border: "unset",
                    background: "unset",
                    textAlign: "unset",
                    fontSize: "unset",
                    boxSizing: "unset"
                },
                cssProps
            ]}
        />
    );
};

export default ButtonDefault;
